module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#speaker",
      toString: function () {
        return this.url;
      }
    }